import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';

import { ReferenceAreasRoutingModule } from './reference-areas-routing.module';
import { ReferenceAreaListComponent } from './components/reference-area-list/reference-area-list.component';
import { ReferenceAreaEditComponent } from './components/reference-area-edit/reference-area-edit.component';
import { UIRouterModule } from '@uirouter/angular';
import { REFERENCE_AREAS_STATES } from './reference-areas.states';
import { ReferenceAreaListLatLngPipe } from './pipes/reference-area-list-lat-lng.pipe';
import { ReferenceAreaEditFormComponent } from './components/reference-area-edit-form/reference-area-edit-form.component';
import { ReferenceAreaImportComponent } from './components/reference-area-import/reference-area-import.component';

@NgModule({
  declarations: [ReferenceAreaListComponent,
    ReferenceAreaEditComponent,
    ReferenceAreaListLatLngPipe,
    ReferenceAreaEditFormComponent,
    ReferenceAreaImportComponent],
  imports: [
    SharedModule,
    ReferenceAreasRoutingModule,
    UIRouterModule.forChild({ states: [...REFERENCE_AREAS_STATES] })
  ],
  exports: [
    ReferenceAreaListLatLngPipe,
    ReferenceAreaEditFormComponent
  ],
  entryComponents: [
      ReferenceAreaListComponent,
      ReferenceAreaEditComponent
  ]
})
export class ReferenceAreasModule { }
